export default __webpack_public_path__ + "static/media/agriServicesInputs.ce55a2ee.svg";